module.exports = __webpack_public_path__ + "assets/img/thumb-AstonRX-Landing-Page.09d6400a.webp";